export default "__VITE_ASSET__6cecbf3f__"